export enum LayoutMapFragmentPosition {
  TOP,
  BOTTOM,
}
